module.exports = __webpack_public_path__ + "img/img-11.678f9d3c.png";